import Modal from "../../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.reducer";
import Loader from "../../UI/Loader";
import Field from "../../UI/Field";
import AuditInfo from "../../UI/AuditInfo";

const FraseSeleccionAplicacionViewModalPlantel = () => {
  const dispatch = useDispatch();
  const {
    viewModalOpen,
    selectedFrase,
    selectedFraseLoading,
    selectedFraseError,
  } = useSelector((state) => state.frasesSeleccionAplicacionPlantel);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de la frase"
      size="lg"
    >
      {selectedFraseLoading && (
        <Loader
          center
          text="Cargando información de la frase..."
          delay={150}
          type="dots"
        />
      )}
      {selectedFraseError && (
        <p className="text-danger">{selectedFraseError}</p>
      )}
      {!selectedFraseLoading && selectedFrase && (
        <div className="row g-4">
          <div className="col-12">
            <Field
              icon="mdi:format-quote-close"
              label="Frase"
              value={selectedFrase.frase}
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:sort-numeric-variant"
              label="Orden"
              value={selectedFrase.orden || "-"}
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:toggle-switch-outline"
              label="Estado"
              value={selectedFrase.is_active ? "Activa" : "Inactiva"}
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:star-outline"
              label="Talento"
              value={selectedFrase.talento_nombre || "-"}
            />
          </div>
          <div className="col-12">
            <AuditInfo
              createdAt={selectedFrase.created_at}
              updatedAt={selectedFrase.updated_at}
              createdBy={selectedFrase.created_by}
              updatedBy={selectedFrase.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default FraseSeleccionAplicacionViewModalPlantel;
